import { useQueryClient } from '@tanstack/react-query'
import { useResourceContext } from 'react-admin'

import { GROUP_MEMBERSHIPS } from '../../config/groupMemberships'

const useInvalidateGroupMembershipRecord = (resourceProp) => {
  const queryClient = useQueryClient()
  const resource = useResourceContext({ resource: resourceProp })

  return (record) => {
    if (!GROUP_MEMBERSHIPS[resource] || !record?.id) return

    return queryClient.invalidateQueries({
      queryKey: [resource, 'getOne', { id: String(record.id), meta: { membershipDetails: true } }],
      exact: true,
      refetchType: 'all',
    })
  }
}

export default useInvalidateGroupMembershipRecord
